import type { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { operationsEventBookPath } from 'restaurantAdmin/paths';
import { Button, ButtonVariants } from '@components/button/Button';

interface ReserveEventButtonProps {
  eventId: string;
}

export const ReserveEventButton = ({ eventId }: ReserveEventButtonProps) => {
  const navigate = useNavigate();

  const handleOnClick = (event: MouseEvent<HTMLButtonElement>) => {
    // The card opens the event for editing when it is clicked.
    event.stopPropagation();
    navigate(operationsEventBookPath(eventId));
  };

  return (
    <Button
      label="Reserve"
      onClick={handleOnClick}
      type="button"
      variant={ButtonVariants.Secondary}
    />
  );
};
